module.exports = __webpack_public_path__ + "img/image-3.a5031b50.png";